import React, { useMemo } from 'react';
import { MdOutlineBolt, MdOutlineSatelliteAlt, MdOutlineGpsFixed } from 'react-icons/md';
import { useSelector } from 'react-redux';

import { Top as TopUI, TopStatusValue } from '@/components/ui/dashboard/Top';

const Top = ({ robot }) => {
  const droneOsd = useSelector((state) => state.telemetry[robot.id].droneOsd);

  const voltage = useMemo(() => {
    if (!droneOsd) return;

    return (droneOsd.battery.batteries[0].voltage / 1000).toFixed(1);
  }, [droneOsd]);

  return (
    <TopUI agentType={robot.model.agentType} owned={robot.isOwned} robotId={robot.id}>
      <TopStatusValue Icon={MdOutlineBolt} value={voltage} unit="V" />
      <TopStatusValue Icon={MdOutlineSatelliteAlt} value={droneOsd?.position_state?.gps_number} style={{ gap: 4 }} />
      <TopStatusValue Icon={MdOutlineGpsFixed} value={droneOsd?.position_state?.rtk_number} style={{ gap: 4 }} />
    </TopUI>
  );
};

export default Top;
